<div class="report-container" *ngIf="reportForm">
    <div *ngIf="showErrors" class="alert valign-children-middle">
        <div class="alert-error" role="img" aria-label="Error">
            <i class="icon-badgealert"></i>
        </div>
        <div>
            <span>{{errorMessage}}</span>
        </div>
    </div>

    <form [formGroup]="reportForm" (ngSubmit)="next(ctnNumber)" autocomplete="off">
        <div class="form-group" *ngFor="let element of pageJson">
            <h2 *ngIf="element.heading">{{element.heading}}</h2>
            <p>{{element.description}}</p>
            <div *ngIf="element.inputType === 'radio'" class="">                
                <div *ngFor="let option of element.options" class="radioContainer"  >                     
                    <label for="{{option.value}}" *ngIf="(option.value==='allFan' ?(!dontShowAllFanRadioButton):true)">
                        <input type="radio" formControlName="{{element.formControlName}}" id="{{option.value}}" (click)="setOptionValue(option.value)" value="{{option.value}}" tabindex="0">
                        <i class="skin"></i>
                        <span class="radioLabel">{{option.label}}</span>                   
                    </label>
               
                    <div *ngIf="option.value == 'singleFan' && showDropdown"
                        [ngClass]="[(showDropdown ? 'singleFan' : '')]">
                  <label for="dropDown" class="dropDown"> Select foundation account number: </label>
                        <app-dropdown [placeholderAriaLabel]="'Select Foundation account number'" *ngIf="showDropdown" [options]="fanList" formControlName="{{element.dropDownFormControlName[option.value]}}" [placeholder]="'Select'"
                            (selectEmit)="selectFan($event, option.value)" id="singleFanDropDown" [prePopulateValue]="preselectValue" class="test" ngDefaultControl></app-dropdown>
                        
                    </div>
                     
                    <div *ngIf="option.value == 'singleDevice' && showTextBox" [ngClass]="{'singleDevice' : showTextBox }">                 
                       <label>Wireless number</label>
                       <!--<div *ngIf="showTextBox">-->
                        <input  type="text" maxlength="12" [ctnmask]=true formControlName="wireless" 
                        (rawChange)="ctnNumber=$event" (ngModelChange)="onChange($event)" autofocus
                        class="form-control textbox" [placeholder]="'Enter 10-digit number'" />                    
                    <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="cta row">
            <button class="btn btn-secondary col-md-3 col-sm-12 pull-right" 
            [disabled]="showError || reportForm.invalid" type="submit" attr.aria-label="Continue">
                Continue
            </button>
            <!--[disabled]="reportForm.invalid-->
            <a href="javascript:void(0)" class="btn btn-link btn-block col-md-2 col-md-offset-6 col-sm-12 btn-cancel pull-right text-right" (click)="cancel()" attr.aria-label="Cancel">Cancel</a>
        </div>
    
    </form>
</div>